import institutionAPI from 'services/institutionAPI'
import toast from 'utils/toast'
import { Pagination, VisualizationFilter } from 'types'

type Params = {
  moduleName?: string
  filters: {
    filter?: VisualizationFilter
    pagination?: Pagination
  }
}

export default async function readVisualizations({ moduleName = '', filters }: Params) {
  const response = await institutionAPI({
    method: 'POST',
    url: `/${moduleName?.toUpperCase()}/visualization/views`,
    data: filters,
  })

  if (!response?.header?.success) {
    toast.error(response?.header?.message)
  }

  return response
}
